import { render, staticRenderFns } from "./cp_pruduct_carousel.vue?vue&type=template&id=75f3626b&scoped=true"
import script from "./cp_pruduct_carousel.vue?vue&type=script&lang=js"
export * from "./cp_pruduct_carousel.vue?vue&type=script&lang=js"
import style0 from "./cp_pruduct_carousel.vue?vue&type=style&index=0&id=75f3626b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f3626b",
  null
  
)

export default component.exports